import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useGroupsState = () => React.useContext(Context) || {}
export const useGroups = () => useGroupsState()?.userGroups || []

const QUERY = gql`
  query Groups($page: Int, $search: String, $sort: [UserGroupSort], $filter: UserGroupFilter) {
    userGroups(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
    }
  }
`

const GroupsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, done, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} disabled={done} />
    </Provider>
  )
}

export default GroupsLoader
